import React from "react";
import Navigation from "../components/landing/Navigation";
import Footer from "../components/landing/Footer";
import AdamHallShop from "../components/landing/AdamHallShop";
import SEO from "../components/seo/SEO";

export default function AdamHallPage() {
    return (
        <div className="min-h-screen bg-nova-black text-white flex flex-col">
            <SEO
                title="Predaj Adam Hall — distribútor"
                description="KB MUSIC je autorizovaným partnerom Adam Hall. Predaj profesionálneho vybavenia Cameo, Gravity a flight case materiálu za distribučné ceny."
            />
            <Navigation />
            <div className="pt-20 flex-1 flex flex-col">
                <AdamHallShop />
            </div>
            <Footer />
        </div>
    );
}
